// extracted by mini-css-extract-plugin
export var excerpt = "blog-post-preview-module--excerpt--069b5";
export var inSidebar = "blog-post-preview-module--inSidebar--840a1";
export var leadMediaThumb = "blog-post-preview-module--leadMediaThumb--36e45";
export var previewItem = "blog-post-preview-module--previewItem--317d8";
export var similarColumn = "blog-post-preview-module--similarColumn--be2de";
export var similarDiv = "blog-post-preview-module--similarDiv--72b50";
export var similarTitle = "blog-post-preview-module--similarTitle--eab37";
export var title = "blog-post-preview-module--title--41496";